import { PORTAL } from "src/constants/AppConstants";
const appSettings = {
    alpha:{
        'appId':'230',
        'appName':'corp reporting',
        'workdocsParentFolderId': 'caaf2ac20403fd5c6c8454cc98530ab50a2ffb4be8aa81c60d8bb6f9bd668ad7',
    },
    dev:{
        'appId':'230',
        'appName':'corp reporting',
        'workdocsParentFolderId': 'caaf2ac20403fd5c6c8454cc98530ab50a2ffb4be8aa81c60d8bb6f9bd668ad7',
    },
    beta:{
        'appId':'230',
        'appName':'corp reporting',
        'workdocsParentFolderId': 'caaf2ac20403fd5c6c8454cc98530ab50a2ffb4be8aa81c60d8bb6f9bd668ad7',
    },
    prod:{
        'appId':'646',
        'appName':'corp reporting',
        'workdocsParentFolderId': '7cad28a28bf743d188b7b11cabe2fb7e6bb2798c31f4deb813d79e96f3bd25e5',
    }
}

export default appSettings;
